module.exports = __webpack_public_path__ + "img/icircle.8bf455c3.svg";